import {
  Box,
  Breadcrumbs,
  Chip,
  Typography,
  Paper,
  IconButton,
  Stack,
  Divider,
  Grid2,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { getFacilityReport } from '../../../helpers/api';
import LoaderSkeleton from '../../common/LoaderSkeleton';
import { Empty } from 'antd';
import ResultViewMeasurements from './result-view/ResultViewMeasurements';
import { reportStatuses, reportTypes, userCats } from '../../../helpers/appstate';
import { openNotification } from '../../../helpers/notification';
import { ArrowBackIosNew, AssessmentOutlined, EventNoteOutlined } from '@mui/icons-material';
import ResultRecommendations from './result-view/ResultRecomendations';

const ResultViewScreen = withRouter(({ history, props }) => {
  const { userCategory } = props;

  const facilityId = history?.location?.pathname?.split('/')[3];
  const quarter = history?.location?.pathname?.split('/')[5];
  const year = history?.location?.pathname?.split('/')[6];

  const [report, setReport] = useState();
  const [reportLoading, setReportLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    fetchReport();
  }, []);

  useEffect(() => {
    if (refresh) refreshReport();
  }, [refresh]);

  const fetchReport = async () => {
    setReportLoading(true);
    try {
      const res = await getFacilityReport(facilityId, quarter, year);
      const { data, status } = res?.result;
      if (status?.code === '00') setReport(data);
      else openNotification({ type: 'error', message: status?.desc });
    } catch (error) {
      openNotification({ type: 'error', message: 'Error fetching report data' });
    } finally {
      setReportLoading(false);
    }
  };

  const refreshReport = async () => {
    try {
      const res = await getFacilityReport(facilityId, quarter, year);
      const { data, status } = res?.result;
      if (status?.code === '00') setReport(data);
    } catch (error) {
      openNotification({ type: 'error', message: 'Refresh failed' });
    } finally {
      setRefresh(false);
    }
  };

  const renderReportStatusStyles = (status) => {
    switch (status) {
      case 'PUBLISHED':
      case 'APPROVED':
        return { color: '#2e7d32', bg: alpha('#2e7d32', 0.1) };
      case 'SUBMITTED':
        return { color: '#1976d2', bg: alpha('#1976d2', 0.1) };
      case 'REJECTED':
        return { color: '#d32f2f', bg: alpha('#d32f2f', 0.1) };
      default:
        return { color: '#757575', bg: alpha('#757575', 0.1) };
    }
  };

  const renderContent = () => {
    // Access Control Logic (Unchanged)
    if (
      report?.reportType === reportTypes.QAQC &&
      userCategory !== userCats.EDM &&
      !report?.isVisible
    ) {
      return <Empty description="Result is not available at the moment." sx={{ mt: 10 }} />;
    }

    if (
      report?.reportType === reportTypes.NORMAL &&
      (userCategory === userCats.PERSONNEL || userCategory === userCats.REGULATOR) &&
      report.reportStatus !== reportStatuses.PUBLISHED
    ) {
      return <Empty description="Result is not available at the moment." sx={{ mt: 10 }} />;
    }

    const statusTheme = renderReportStatusStyles(report?.reportStatus);

    return (
      <Box>
        {/* TOP HEADER SECTION */}
        <Stack
          direction="row"
          alignItems="flex-start"
          justifyContent="space-between"
          sx={{ mb: 3 }}
        >
          <Box>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
              <IconButton
                onClick={() => history.push('/results')}
                size="small"
                sx={{ bgcolor: '#fff', border: '1px solid', borderColor: 'divider' }}
              >
                <ArrowBackIosNew sx={{ fontSize: 14 }} />
              </IconButton>
              <Breadcrumbs separator="›" sx={{ '& .MuiBreadcrumbs-separator': { fontSize: 20 } }}>
                <Link to="/results" style={{ textDecoration: 'none' }}>
                  <Typography variant="body2" color="primary" sx={{ fontWeight: 600 }}>
                    Results
                  </Typography>
                </Link>
                <Typography variant="body2" color="textSecondary">
                  {report?.reportTitle}
                </Typography>
              </Breadcrumbs>
            </Stack>

            <Stack direction="row" alignItems="center" spacing={2}>
              <Typography variant="h5" fontWeight={700} color="text.primary">
                {report?.reportTitle}
              </Typography>
              <Chip
                label={report?.reportStatus}
                size="small"
                sx={{
                  bgcolor: statusTheme.bg,
                  color: statusTheme.color,
                  fontWeight: 700,
                  fontSize: '0.7rem',
                  borderRadius: '6px',
                }}
              />
              <Chip
                label={report?.reportType}
                size="small"
                sx={{
                  bgcolor:
                    report?.reportType === reportTypes.QAQC
                      ? alpha('#ed6c02', 0.1)
                      : alpha('#0288d1', 0.1),
                  color: report?.reportType === reportTypes.QAQC ? '#ed6c02' : '#0288d1',
                  fontWeight: 700,
                  fontSize: '0.7rem',
                  borderRadius: '6px',
                }}
              />
            </Stack>
          </Box>
        </Stack>

        {/* DETAILS SUB-HEADER */}
        {/* <Paper
          elevation={0}
          sx={{ p: 2, mb: 3, borderRadius: '16px', border: '1px solid', borderColor: 'divider' }}
        >
          <Grid2 container spacing={2}>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Box
                  sx={{
                    p: 1,
                    borderRadius: '10px',
                    bgcolor: alpha('#1976d2', 0.1),
                    color: 'primary.main',
                    display: 'flex',
                  }}
                >
                  <AssessmentOutlined sx={{ fontSize: 20 }} />
                </Box>
                <Box>
                  <Typography variant="caption" color="textSecondary" fontWeight={600}>
                    FACILITY
                  </Typography>
                  <Typography variant="body2" fontWeight={700}>
                    {report?.facility || 'N/A'}
                  </Typography>
                </Box>
              </Stack>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Box
                  sx={{
                    p: 1,
                    borderRadius: '10px',
                    bgcolor: alpha('#9c27b0', 0.1),
                    color: '#9c27b0',
                    display: 'flex',
                  }}
                >
                  <EventNoteOutlined sx={{ fontSize: 20 }} />
                </Box>
                <Box>
                  <Typography variant="caption" color="textSecondary" fontWeight={600}>
                    PERIOD
                  </Typography>
                  <Typography variant="body2" fontWeight={700}>
                    Quarter {report?.reportQuarter}, {report?.reportYear}
                  </Typography>
                </Box>
              </Stack>
            </Grid2>
          </Grid2>
        </Paper> */}

        <Box>
          <ResultViewMeasurements
            props={props}
            report={report}
            onRefresh={() => setRefresh(true)}
          />
        </Box>
      </Box>
    );
  };

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: '#F4F6F8', minHeight: '100vh', mt: -1 }}>
      {reportLoading ? (
        <Box sx={{ p: 4 }}>
          <LoaderSkeleton />
          <Divider sx={{ my: 3 }} />
          <LoaderSkeleton />
        </Box>
      ) : !report ? (
        <Box sx={{ py: 10, textAlign: 'center' }}>
          <Empty description="Report not found" />
        </Box>
      ) : (
        <>
          {renderContent()}
          <ResultRecommendations facilityId={facilityId} quarter={quarter} year={year} showActions/>
        </>
      )}
    </Box>
  );
});

export default ResultViewScreen;
